import { createContainer, createHook, createStore } from 'react-sweet-state';
const initialState = {
  forms: [],
  loading: false,
  sortKey: 'Name',
  sortOrder: 'ASC'
};
const actions = {
  load: () => ({
    setState,
    getState
  }, {
    errorUtils,
    projectFormApi
  }) => {
    if (getState().loading) {
      return Promise.resolve();
    }
    setState({
      loading: true
    });
    return projectFormApi.getForms().then(newForms => {
      setState({
        forms: newForms,
        loading: false
      });
    }).catch(error => {
      errorUtils.reportError(error, {
        id: 'getForms'
      });
      return Promise.reject(error);
    });
  },
  onSort: sortDetails => ({
    setState
  }) => {
    setState({
      sortKey: sortDetails === null || sortDetails === void 0 ? void 0 : sortDetails.key,
      sortOrder: sortDetails === null || sortDetails === void 0 ? void 0 : sortDetails.sortOrder
    });
  }
};
const Store = createStore({
  initialState,
  actions,
  name: 'ProjectFormsStore'
});
export const ProjectFormsContainer = createContainer(Store, {
  onInit: () => ({
    dispatch
  }) => dispatch(actions.load())
});
export const useProjectFormsController = createHook(Store);

// Does not trigger a re-render on state change:
export const useProjectFormsControllerActions = createHook(Store, {
  selector: null
});